import { Routes } from "@angular/router";
import { PublicViewGuard } from "./core/guards/public-view.guard";
import { LoginComponent } from "./public/views/login/login.component";
import { ErrorApiComponent } from "./shared/components/error-api/error-api.component";
import { PrivateViewGuard } from "./core/guards/private-view.guard";
import { PrivateComponent } from "./private/private.component";
import { ArticleTypesComponent } from "./private/views/article-types/article-types.component";
import { ArticlesComponent } from "./private/views/articles/articles.component";
import { ChangePasswordComponent } from "./private/views/change-password/change-password.component";
import { CustomersComponent } from "./private/views/customers/customers.component";
import { MachinesComponent } from "./private/views/machines/machines.component";
import { ProductionOrderDetailComponent } from "./private/views/production-order-detail/production-order-detail.component";
import { ProductionOrderProcessDetailComponent } from "./private/views/production-order-process-detail/production-order-process-detail.component";
import { ProductionOrdersComponent } from "./private/views/production-orders/production-orders.component";
import { ProductionProcessesComponent } from "./private/views/production-processes/production-processes.component";
import { RoutesComponent } from "./private/views/routes/routes.component";
import { ScrapCausesComponent } from "./private/views/scrap-causes/scrap-causes.component";
import { ScrapReasonsComponent } from "./private/views/scrap-reasons/scrap-reasons.component";
import { ScreensComponent } from "./private/views/screens/screens.component";
import { UsersComponent } from "./private/views/users/users.component";
import { ArticleFamiliesComponent } from "./private/views/article-families/article-families.component";
import { StatusesComponent } from "./private/views/statuses/statuses.component";
import { MachineValuesComponent } from "./private/views/machine-values/machine-values.component";
import { ConfigurationComponent } from "./private/views/configuration/configuration.component";
import { MachinesDashboardComponent } from "./private/views/machines-dashboard/machines-dashboard.component";
import { MaintenancesComponent } from "./private/views/maintenances/maintenances.component";
import { MaintenancesCalendarComponent } from "./private/views/maintenances-calendar/maintenances-calendar.component";
import { MaintenanceRequestsComponent } from "./private/views/maintenance-requests/maintenance-requests.component";
import { PreventiveMaintenancesComponent } from "./private/views/preventive-maintenances/preventive-maintenances.component";
import { PackagingsComponent } from "./private/views/packagings/packagings.component";
import { ValidatePausesComponent } from "./private/views/validate-pauses/validate-pauses.component";
import { PauseReasonsComponent } from "./private/views/pause-reasons/pause-reasons.component";
import { hasViewPermissionGuard } from "./core/guards/permission-view.guard";
import { LossReasonsComponent } from "./private/views/loss-reasons/loss-reasons.component";
import { DashboardComponent } from "./private/views/dashboard/dashboard.component";
import { PackagingTypesComponent } from "./private/views/packaging-types/packaging-types.component";
import { ConsumptionReportComponent } from "./private/views/consumption-report/consumption-report.component";
import { PermissionsComponent} from "./private/views/permissions/permissions.component";

export const routes: Routes = [
    {
        path: 'auth/login',
        component: LoginComponent,
        canActivate: [PublicViewGuard],
    },
    {
        path: '',
        component: PrivateComponent,
        canActivate: [PrivateViewGuard],
        children: [
            {
                path: 'screens',
                component: ScreensComponent,
                //canDeactivate: [PendingChangesGuard],
                canActivate: [() => hasViewPermissionGuard('screens', '')]
            },
            {
                path: 'machines',
                component: MachinesComponent,
                //canDeactivate: [PendingChangesGuard],
                canActivate: [() => hasViewPermissionGuard('machines', '')]
            },
            {
                path: 'articles',
                component: ArticlesComponent,
                //canDeactivate: [PendingChangesGuard],
                canActivate: [() => hasViewPermissionGuard('articles', '')]
            },
            {
                path: 'article-types',
                component: ArticleTypesComponent,
                //canDeactivate: [PendingChangesGuard],
                canActivate: [() => hasViewPermissionGuard('articleTypes', '')]
            },
            {
                path: 'article-families',
                component: ArticleFamiliesComponent,
                //canDeactivate: [PendingChangesGuard],
                canActivate: [() => hasViewPermissionGuard('articleFamilies', '')]
            },
            {
                path: 'packagings',
                component: PackagingsComponent,
                //canDeactivate: [PendingChangesGuard],
                canActivate: [() => hasViewPermissionGuard('packagings', '')]
            },
            {
                path: 'packaging-types',
                component: PackagingTypesComponent,
                canActivate: [() => hasViewPermissionGuard('packagingsTypes', '')]
            },
            {
                path: 'production-orders',
                component: ProductionOrdersComponent
            },
            {
                path: 'production-orders/:idOrder',
                component: ProductionOrderDetailComponent,
                //canDeactivate: [PendingChangesGuard]
                canActivate: [() => hasViewPermissionGuard('productionOrderDetail', '')]
            },
            {
                path: 'production-orders/:idOrder/process/:idOrderProcess',
                component: ProductionOrderProcessDetailComponent,
                //canDeactivate: [PendingChangesGuard]
                canActivate: [() => hasViewPermissionGuard('productionOrderProcessDetail', '')]
            },
            {
                path: 'scrap-causes',
                component: ScrapCausesComponent,
                //canDeactivate: [PendingChangesGuard]
                canActivate: [() => hasViewPermissionGuard('scrapCauses', '')]
            },
            {
                path: 'scrap-reasons',
                component: ScrapReasonsComponent,
                //canDeactivate: [PendingChangesGuard]
                canActivate: [() => hasViewPermissionGuard('scrapReasons', '')]
            },
            {
                path: 'change-password',
                component: ChangePasswordComponent
            },
            {
                path: 'configuration',
                component: ConfigurationComponent,
                canActivate: [() => hasViewPermissionGuard('app', 'configurations')]
            },
            {
                path: 'users',
                component: UsersComponent,
                canActivate: [() => hasViewPermissionGuard('users', '')]
            },
            {
                path: 'customers',
                component: CustomersComponent,
                canActivate: [() => hasViewPermissionGuard('customers', '')]
            },
            {
                path: 'production-routes',
                component: RoutesComponent,
                canActivate: [() => hasViewPermissionGuard('productionRoutes', '')]
            },
            {
                path: 'production-processes',
                component: ProductionProcessesComponent,
                canActivate: [() => hasViewPermissionGuard('productionProcesses', '')]
            },
            {
                path: 'statuses',
                component: StatusesComponent,
                canActivate: [() => hasViewPermissionGuard('statuses', '')]
            },
            {
                path: 'machine-measurements',
                component: MachineValuesComponent,
                canActivate: [() => hasViewPermissionGuard('machineMeasurements', '')]
            },
            {
                path: 'machines-dashboard',
                component: MachinesDashboardComponent,
                canActivate: [() => hasViewPermissionGuard('machinesDashboard', '')]
            },
            {
                path: 'maintenances',
                component: MaintenancesComponent,
                canActivate: [() => hasViewPermissionGuard('maintenances', '')]
            },
            {
                path: 'maintenances-calendar',
                component: MaintenancesCalendarComponent,
                canActivate: [() => hasViewPermissionGuard('maintenancesCalendar', '')]
            },
            {
                path: 'maintenance-requests',
                component: MaintenanceRequestsComponent,
                canActivate: [() => hasViewPermissionGuard('maintenanceRequests', '')]
            },
            {
                path: 'preventive-maintenances',
                component: PreventiveMaintenancesComponent,
                canActivate: [() => hasViewPermissionGuard('preventiveMaintenances', '')]
            },
            {
                path: 'validate-pauses',
                component: ValidatePausesComponent,
                canActivate: [() => hasViewPermissionGuard('validatePauses', '')]
            },
            {
                path: 'pause-reasons',
                component: PauseReasonsComponent,
                canActivate: [() => hasViewPermissionGuard('pauseReasons', '')]
            },
            {
                path: 'loss-reasons',
                component: LossReasonsComponent,
                canActivate: [() => hasViewPermissionGuard('lossReasons', '')]
            },
            {
                path: 'dashboards',
                component: DashboardComponent,
                canActivate: [() => hasViewPermissionGuard('dashboards', '')]
            },
            {
                path: 'consumption-report',
                component: ConsumptionReportComponent,
                canActivate: [() => hasViewPermissionGuard('articles', '')]
            },
            {
                path: 'permissions',
                component: PermissionsComponent,
                canActivate: [() => hasViewPermissionGuard('permissions', '')]
            }
        ],
    },
    { path: 'error', component: ErrorApiComponent },
    { path: '**', component: LoginComponent, canActivate: [PublicViewGuard] },
];
